module.exports = __webpack_public_path__ + "img/productDefault.b7ec13c2.png";